export default "__VITE_ASSET__CHbi_jpJ__"